// extracted by mini-css-extract-plugin
export var aggregationCell = "_2f-h";
export var aggregationRow = "_2f-g";
export var borderlessSpinnerContainer = "_2f-2";
export var closeIcon = "_2f-9";
export var expandIcon = "_2f-a";
export var expanded = "_2f-b";
export var filterDropdown = "_2f-c";
export var filterDropdownDivider = "_2f-7";
export var filterDropdownHeader = "_2f-f";
export var filterDropdownItem = "_2f-e";
export var filterDropdownModal = "_2f-d _2f-c";
export var filterItem = "_2f-6";
export var normalCellWithAdjustableBorder = "_2f-8";
export var pinButtonContainer = "_2f-i";
export var pinIcon = "_2f-j";
export var pinIconActive = "_2f-k";
export var spinner = "_2f-0";
export var spinnerContainer = "_2f-1";
export var tableContainer = "_2f-3";
export var tableContentInner = "_2f-5";
export var tableContentWrapper = "_2f-4";
export var viewButtonContainer = "_2f-l";